import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { DashboardAdminListWire } from './types';
import { DashboardSearchModel } from './types-store';

export const api = {

  loadList: async (
    model: DashboardSearchModel, startIndex: number, maxResults: number
  ): Promise<DashboardAdminListWire> => {

    const response = await new RemoteAdminData(endpoints.searchDashboards)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteDashboard: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.dashboardItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
